import { cva } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';

type FormGroupProps = {
    label: string;
    required?: boolean;
    htmlFor?: string;
    error?: string;
    className?: string;
} & HTMLAttributes<HTMLDivElement>;

const formGroup = cva(['form-group', 'margin-bottom-0'], {
    variants: {
        error: {
            true: ['has-feedback', 'has-error'],
        },
    },
});

const FormGroup = ({
    label,
    required,
    htmlFor = `${label}-input`,
    error,
    className,
    children,
    ...props
}: FormGroupProps) => (
    <div className={formGroup({ error: !!error, className })} {...props}>
        <label className='control-label' htmlFor={htmlFor}>
            {label}
            {required && <sup>*</sup>}
        </label>
        {children}
        {error ? (
            <>
                <span className='help-block'>{error}</span>
                <span className='display-flex align-items-center justify-content-center form-control-feedback uikit-icon icon-error-sign' />
            </>
        ) : null}
    </div>
);

export default FormGroup;
